import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideEnvironmentNgxMask, IConfig } from 'ngx-mask';
import { DataModule } from '@data/data.module';
import { InfraModule } from '@infra/infra.module';
import { ModulesModule } from '@modules/modules.module';
import { AppRoutingModule } from '@app/app-routing.module';
import { ComponentsModule } from '@components/components.module';
import { AppComponent } from '@app/app.component';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MomentDateAdapter, MOMENT_DATE_FORMATS } from '@shared/utils/moment-adapter.util';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginatorIntlPtBr } from './shared/custom-services/mat-paginator-intl.service';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DataModule,
    InfraModule,
    ModulesModule,
    ComponentsModule,
    BrowserAnimationsModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "pt-BR" },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    {
      provide: MatPaginatorIntl,
      useClass: MatPaginatorIntlPtBr
    },
    provideEnvironmentNgxMask(maskConfig),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
